import CategoryRow from './CategoryRow';

export default CategoryRow;
